import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-allergens',
  templateUrl: 'allergens.html',
})
export class AllergensPage {
  @Input() allergens;
  @Input() width: string = '28';

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    public globals: Globals) {

  }

  styleIcon(){
   
    let styles = {
        'width': this.width+'px',
    };

    return styles;

}
}



// WEBPACK FOOTER //
// ./src/pages/components/allergens/allergens.ts